import { Link } from "react-router-dom";
import { useFetch } from "../lib/useFetch";
import type { Alert, ClientSummary, Device } from "../lib/types";

export default function Dashboard() {
  const clients = useFetch<ClientSummary[]>("/api/clients");
  const devices = useFetch<Device[]>("/api/devices");
  const alerts = useFetch<Alert[]>("/api/alerts");

  const online = devices.data?.filter((d) => d.isOnline).length ?? 0;
  const total = devices.data?.length ?? 0;
  const danger = alerts.data?.filter((a) => a.severity === "danger").length ?? 0;

  return (
    <>
      <div className="topbar">
        <h1>Dashboard</h1>
      </div>

      <div
        className="grid"
        style={{ gridTemplateColumns: "repeat(4, 1fr)", marginBottom: 20 }}
      >
        <div className="card stat">
          <span className="n">{clients.data?.length ?? "—"}</span>
          <span className="l">Clients</span>
        </div>
        <div className="card stat">
          <span className="n">
            {online}
            <span className="muted" style={{ fontSize: 14 }}>
              {" "}
              / {total}
            </span>
          </span>
          <span className="l">Devices online</span>
        </div>
        <div className="card stat">
          <span className="n">{alerts.data?.length ?? "—"}</span>
          <span className="l">Open alerts</span>
        </div>
        <div className="card stat">
          <span className="n" style={{ color: danger ? "var(--danger)" : undefined }}>
            {danger}
          </span>
          <span className="l">Critical alerts</span>
        </div>
      </div>

      <div className="card" style={{ marginBottom: 20 }}>
        <h2>Clients</h2>
        {clients.error && <div className="error">{clients.error}</div>}
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Devices</th>
              <th>Tickets</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {clients.data?.map((c) => (
              <tr key={c.id}>
                <td>
                  <Link to={`/devices?clientId=${c.id}`}>{c.name}</Link>
                </td>
                <td>{c._count.devices}</td>
                <td>{c._count.tickets}</td>
                <td>
                  <span className={`pill ${c.isActive ? "ok" : "danger"}`}>
                    {c.isActive ? "active" : "inactive"}
                  </span>
                </td>
              </tr>
            ))}
            {clients.data?.length === 0 && (
              <tr>
                <td colSpan={4} className="muted">
                  No clients assigned.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className="card">
        <h2>Recent critical alerts</h2>
        <table>
          <thead>
            <tr>
              <th>Severity</th>
              <th>Title</th>
              <th>Device</th>
              <th>Client</th>
              <th>When</th>
            </tr>
          </thead>
          <tbody>
            {alerts.data
              ?.slice(0, 8)
              .map((a) => (
                <tr key={a.id}>
                  <td>
                    <span className={`pill dot ${a.severity}`}>{a.severity}</span>
                  </td>
                  <td>{a.title}</td>
                  <td>
                    {a.device
                      ? `${a.device.hostname} (${a.device.username})`
                      : "—"}
                  </td>
                  <td>{a.client?.name ?? "—"}</td>
                  <td className="muted">
                    {new Date(a.createdAt).toLocaleString()}
                  </td>
                </tr>
              ))}
            {alerts.data?.length === 0 && (
              <tr>
                <td colSpan={5} className="muted">
                  Nothing needs attention.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
